export interface InteractionFilter {

  value?: string;

  lastDays?: TimeFilterTypes;

  important?: boolean;

}

export enum TimeFilterTypes {
  ALL = null,
  LAST_YEAR = 365,
  LAST_MONTH = 30
}
